import { setLocalStorage, getLocalStorage } from "./GetSetStorage";
import { translateEnRu, dictionaryEn, dictionaryRu } from "./Translate";
const openweathermapKey = "dc35f23644b47df259b3913dd1b09f55";
//const weatherapiKey = "495efc9d82f64738be8175409232202"; //Прогноз погоды на JS. От дизайна до работы с API. ВебКадеми
const weatherIcon = document.querySelector(".weather-icon");
const temperature = document.querySelector(".temperature");
const weatherError = document.querySelector(".weather-error");
const weatherDescription = document.querySelector(".weather-description");
const wind = document.querySelector(".wind");
const humidity = document.querySelector(".humidity");
let cityInput = document.querySelector(".city");
let saveCity = getLocalStorage("city");
let city;
window.addEventListener("beforeunload", () => {
  setLocalStorage("city", cityInput.value);
});
if (saveCity != undefined) {
  cityInput.value = saveCity;
  //console.log(saveCity);
} else {
  cityInput.addEventListener("change", function (e) {
    if (e.keycode == 13) {
      setLocalStorage("city", cityInput.value);
      cityInput.placeholder = cityInput.value;
    }
  });
}
async function getWeather() {
  let langCurrent = getLocalStorage("lang");
  //const url = `http://api.weatherapi.com/v1/current.json?key=${weatherapiKey}&q=London`;
  const url = `https://api.openweathermap.org/data/2.5/weather?q=${cityInput.value}&lang=${langCurrent}&appid=${openweathermapKey}&units=metric`;
  const res = await fetch(url);
  const data = await res.json();

  weatherIcon.className = "weather-icon owf";
  weatherIcon.classList.add(`owf-${data.weather[0].id}`);
  temperature.textContent = `t ${Math.round(data.main.temp)}°C`;
  if (langCurrent === "ru") {
    wind.textContent = `ветер ${Math.round(data.wind.speed)}км/ч`;
    humidity.textContent = `влажность ${data.main.humidity}%`;
  }
  wind.textContent = `wind ${Math.round(data.wind.speed)}km/h`; //Todo ф-ю к-рая будет переводить wind с пом-ю dictionaryRu
  humidity.textContent = `humidity ${data.main.humidity}%`;
  weatherDescription.textContent = data.weather[0].description;
  console.log(data.weather[0].id, data.weather[0].description, data.main.temp);
}
getWeather();

export { getWeather };
